import Earnings from "../../../../components/company/pay-slip/earnings"


const EarningsPage = () => {
    return <Earnings/>
}

export default EarningsPage;